import { useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

type ScrollPosition = {
  x: number;
  y: number;
};

export function ScrollRestoration() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const positions = useRef(new Map<string, ScrollPosition>());

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    const key = location.key;
    const saved = positions.current.get(key);
    const frame = window.requestAnimationFrame(() => {
      const previousScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = "auto";
      if (navigationType === "POP" && saved) {
        window.scrollTo(saved.x, saved.y);
      } else {
        window.scrollTo(0, 0);
      }
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
    });

    return () => {
      window.cancelAnimationFrame(frame);
      positions.current.set(key, { x: window.scrollX, y: window.scrollY });
    };
  }, [location.key, navigationType]);

  return null;
}
